// extracted by mini-css-extract-plugin
module.exports = {"ContentBox":"ContentBox-module__ContentBox___pPTbV"};